import { NamedPaymentMethods } from '@paywall/types';
import { GetPaymentMethods } from '@paywall/types/getPaymentMethods';

export default function convertToNamedPaymentMethods(methods: GetPaymentMethods['data']['methods']) {
  const namedMethods = methods.reduce((withNames: NamedPaymentMethods, noNames: GetPaymentMethods['data']['methods'][0]) => {
    // Create new object with method names as keys
    const methodType = noNames.method;

    return (withNames = { ...withNames, [methodType]: noNames });
  }, {} as NamedPaymentMethods);

  return namedMethods;
}
